<template>
  <v-alert class="ma-0 fixed-position"
           transition="slide-y-transition"
           tile v-model="data.show"
           :type="data.type"
           dismissible>
    <span>{{ data.message }}</span>
  </v-alert>
</template>

<script>
export default {
  name: "AlertComponent",
  data() {
    return {
      data: {
        type: 'success',
        message: null,
        show: false
      }
    }
  },
  mounted() {
    this.$root.$on('alert', (data) => {
      this.data = data;
    })
  }
}
</script>

<style scoped>
  .fixed-position {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 5;
  }
</style>